
import { Grid } from "@mui/material"
import AuthFooter from "src/components/layout/auth-footer"
import AuthHeader from "src/components/layout/auth-header"
import MainCard from "../../../common/main-card"
import LoginForm from "../components/login-form"

// -------------------------------------------|| DESKTOP LOGIN - PAGE COMPONENTS ||-------------------------------------

const DesktopLogin = ({ userData }) => {
  return (
    <Grid
      container
      justifyContent='center'
      alignItems='center'
      sx={{ minHeight: "100vh" }}
      className='pattern-background'
    >
      <Grid item xs={12} sm={8} md={5} lg={4} xl={3}>
        <MainCard shadow={3} sx={{ borderRadius: "12px", p: 3 }}>
          {/* Login Header */}
          <AuthHeader page='login' title='ورود' subTitle='لطفا شماره موبایل خود را وارد کنید' />
          {/* Login Form */}
          <LoginForm userData={userData} />

          {/*  Login Footer */}
          <AuthFooter page='register' />
        </MainCard>
      </Grid>
      {/* <AppLoading isLoading={loading} /> */}
    </Grid>
  )
}

export default DesktopLogin
